import { Box, Stack, styled } from "@mui/material"
import theme from "../../app/theme"

export const CustomerContainer = styled(Stack)`
  display: flex;
  flex: 1;
  background: white;
  padding: 20px;
  position: relative;
  height: 90dvh;
`

export const CustomerFilterWrapper = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "10px",
  marginBottom: "16px",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}))

export const StyledBox = styled(Box)(() => ({
  justifyContent: "space-between",
  gap: 2,
  alignItems: "flex-start",
}))
